<po-modal #modal
  p-size="sm"
  p-title={{literalsCp?.strSelecionarProjeto}}
  [p-primary-action]="salvar"
  [p-secondary-action]="cancelar"
  >

  <div class="po-row">
    <label class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-font-bold cp-np">{{literalsCp?.strSelecionarColigada}}</label>

    <po-combo #combocoligada
    class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-font-bold cp-np"
    name="coligada"
    (p-change)="SelecionarColigada($event)"
    p-field-value="code"
    p-field-label="name"
    [p-filter-service]="serviceColigada"
    [p-literals]="literalsCustom"
    p-required
  >
    <ng-template p-combo-option-template let-option>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np">
          <div class="po-font-text-large-bold">{{ option.label }}</div>
          <div class="po-font-text-smaller">Código: {{ option.value['code'] }}</div>
        </div>
      </div>
    </ng-template>
   </po-combo>
  </div>

  <div class="po-row">
    <label class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-font-bold cp-np">{{literalsCp?.strSelectProjeto}}</label>

    <po-combo #comboprojeto
    class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np"
    name="projeto"
    (p-change)="SelecionarProjeto($event)"
    p-field-value="projectId"
    p-field-label="description"
    [p-filter-service]="serviceProjeto"
    [p-literals]="literalsCustom"
    [p-disabled]="coligadaSelecionada"
    p-required
  >
    <ng-template p-combo-option-template let-option>
      <div class="po-row">
        <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12">
          <div class="po-font-text-large-bold">{{ option.label }}</div>
          <div class="po-font-text-smaller">{{ option.value['projectCode'] }} -
                                            {{ option.value['projectTypeDescription'] }} -
                                            REV:{{ option.value['review'] }} -
                                            {{ option.value['descriptionPosition'] }}</div>
        </div>
      </div>
    </ng-template>
   </po-combo>
  </div>
  <po-loading-overlay [hidden]="isHideLoading" p-text={{literalsCp?.strVerificandoPermissao}} >
  </po-loading-overlay>

</po-modal>
